import { Dayjs } from "dayjs";

type FilterType = "day" | "week" | "month" | "year";

export interface CustomCalendarSelectorProps {
  value: Dayjs;
  view: FilterType;
  maxDate?: Dayjs;
  minDate?: Dayjs;
  onChange: (date: Dayjs) => void;
}

export const addByView = (
  date: Dayjs,
  view: CustomCalendarSelectorProps["view"],
  d: number
) => {
  return date.add(d, view);
};

// Picker views and openTo
export function getViews(
  view: CustomCalendarSelectorProps["view"]
): CustomCalendarSelectorProps["view"][] {
  if (view === "day" || view === "week") {
    return ["year", "month", "day"];
  } else if (view === "month") {
    return ["year", "month"];
  } else {
    return ["year"];
  }
}

// function to open the view directly
export function getOpenTo(
  view: CustomCalendarSelectorProps["view"]
): "year" | "month" | "day" {
  if (view === "day" || view === "week") {
    return "day";
  }
  return view;
}
